export enum EContractorPaymentType {
  REGULAR = "regular",
  REIMBURSEMENT = "reimbursement",
}
